import {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../Classes/Api';
import DOMPurify from 'dompurify';

import '../assets/css/quill.core.css';

const CMS = (props) => {
	const [content, setContent] = useState({});
	const navigate = useNavigate();

	useEffect(() => {
		api.callApi('cms/page/' + props.id, 'GET').then(data => {
			data.content = DOMPurify.sanitize(data.content);
			setContent(data);
		}).catch(error => {
			navigate('/404');
			//redirect('/404');
		});
	}, [props.id]);

	return (
		<>
			<h1>{content.title}</h1>
			
			<div className="blogContent ql-editor" dangerouslySetInnerHTML={{ __html: content.body_html }} />
		</>
	);
}

export default CMS;
